export { default as createHighlightTextWrapper } from './create-highlight-text-wrapper';
